import React from 'react';
import classNames from 'classnames';
import InputField from 'components/pure/utils/form/InputField';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import './TopicFormNameEditor.styl';

/** Name editor used in the topic form header. */
export default class TopicFormNameEditor extends React.PureComponent {
  componentDidMount() {
    if (this.ref) {
      this.ref.focus();
    }
  }

  render() {
    const {name, onCancel, onChange, onSave} = this.props;
    const nameIsValid = name && name.trim() !== '';
    const saveIfValid = () => {
      if (nameIsValid) {
        onSave();
      }
    };
    return (
      <div className="admin-topic-form-header-name-editor">
        <div className="name-group">
          <div className="label">Topic Name</div>
          <div className="lower-row">
            <InputField
              ref={r => (this.ref = r)}
              value={name}
              onChange={onChange}
              placeholder="Enter topic name"
            />
            <div
              className={classNames('icon save', {
                disabled: !nameIsValid,
              })}>
              <CheckIcon onClick={saveIfValid} />
            </div>
            <div className="icon cancel">
              <CloseIcon onClick={onCancel} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
